export default "__VITE_ASSET__6f7ed855__"